<template>
  <el-container  class="case_nft_container w">
      
      <div class="service_nft">
          <div class="_icon"><img src="../assets/blockchain_icon.png"></div>
          <div class="_title"><h2>数字上链 - 打造我国优秀文化数字IP</h2></div>
      
          <div class="_intro">
              积极响应国家关于大力推进优秀文化IP数字化的号召，寻找并帮助优秀项目落地数字化创新，借助区块链的独特优势扩大积极影响。
          </div>
      </div>

      <el-main>
      <el-carousel :height="changeHeight" indicator-position="inside" triger="click" autoplay="false">
          <el-carousel-item v-for="(item,index) in cases" :key="index">

          <el-row>

              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <div class="case_post_nft" :style="case_height">
                      <img class="post" :src="item.post"/>
                  </div>
              </el-col>


              <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <div class="nft_demos" :style="case_height_b">

                      <el-col :span=12>
                          <div class="nft">
                              <div class="show el-col el-col-20">
                                  <div class="video">
                                      <video autoplay="autoplay" loop="loop" muted="muted"><source :src="item.video" type="video/mp4"></video>
                                   </div>
                                   <div class="words w">
                                       {{item.words}}
                                   </div>
                                   <div class="stage">
                                       <img src="../assets/stage.png"/>
                                    </div>
                               </div>
                               <div class="name el-col el-col-4">
                                   <img :src="item.name"/>
                               </div>
                          </div>
                      </el-col>

                      <el-col :span=12 class="demos">
                          
                              <img :src="item.demos"/>
                          
                      </el-col>
                   
                   </div>
              </el-col>
         
         </el-row>
         </el-carousel-item>
         </el-carousel>

         <div class="case_nft">
         
          <div class="case_title">    
              <div><h3>国内首家高品质合规影视数字藏品平台——空相</h3></div>
          </div>

          <div class="case_intro">
              <div>
             我们为国产知名影视作品《狙击手》、《四海》以及《这个杀手不太冷静》提供包括：藏品设计与营销策划、数字IP上链标准策划(至信链)，以及与相关法律法规相匹配的严格的合规化咨询等在内的一站式专业服务，开发出极具收藏价值与观赏性的“3D动态影视徽章”，创造了每期发售必被秒光的成功效果。其中，极具爱国主义情怀的《狙击手》藏品，因“若生于和平”系列巧妙地通过今夕对比，让人们真切地感受当今幸福的来之不易，获得市场的好评与追捧!</div>
          </div>
         </div>
      </el-main>
  
  </el-container>

</template>


<script>
const cases = [
    {
        post: require('../assets/jjsbb2.png'),
        video:require('../assets/case_nft_jjs_v2.mp4'),
        demos:require('../assets/case_nft_jjs_demos.png'),
        name:require('../assets/case_nft_jjs_name2.png'),
        words:'你一个神枪手能顶一个连!',
      },
     
     {
        post:require('../assets/sh.png'),
        video:require('../assets/case_nft_sh_v1.mp4'),
        demos:require('../assets/case_nft_sh_demos.png'),
        name:require('../assets/case_nft_sh_name.png'),
        words:'做好了就会像没做一样。',                
         },

   {

        post:require('../assets/ssbb1.png'),
        video:require('../assets/case_nft_ss_v1.mp4'),
        demos:require('../assets/case_nft_ss_demos.png'),
        name:require('../assets/case_nft_ss_name.png'),
        words:'我是卡尔·赛西里奥！',                

       }


]
export default {
    name:'CasesList',
    data(){
        return{
            changeHeight:'',
            case_height:{
                height:''
                },
            case_height_b:{
                height:''},
            cases:cases,
            }
        },
    
    mounted(){

        this.$nextTick(function(){
             // 屏幕宽度<992时，案例内容的高度（case_height）保持为宽度*0.5
          this.case_height.height = '320px';
          if(window.innerWidth<992){
              this.case_height.height = window.innerWidth*.5+'px';
              this.case_height_b.height = window.innerWidth*0.5+10+'px';
              this.changeHeight = window.innerWidth+10+'px';
              console.log(this.changeHeight);
              }
          })
       }
    }

</script>

<style scoped>

.case_nft_container {
background-color: #32313B;
flex-direction:column;
}

.service_nft{
    padding:70px 30px 50px 30px}

.el-main{
    padding-top:20px}


.case_post_nft {
    height:100%
    }

.case_post_nft img, .stage img, .name img{
    width:100%}

.demos img{
    width:90%}

.nft_demos{
    
    background-color:#25242C;
    }

.nft_demos,.nft {
    display:flex;
    }
.demos {
    display:flex;
    align-items:center;
    padding-right:20px;
    }
.nft .show {
    background-image:url('../assets/case_nft_light.png');
    background-repeat:no-repeat;
    background-position: center top;
    padding-top:12px;
    }
.nft .video{
    }
.words {
    font-size: 0.5rem;
    margin-top: -11px;
    text-align: center;
    padding:0 20px;
    }
.nft video{
    width:65%;
    mix-blend-mode:lighten;
    }

.stage{
    padding: 10px 25px 0 25px;
    }

.name {
    }

.name img{
    width: 70%;
    margin: 12px 0px 0 -35px;
    }

.nft stage {
    padding:0 20px;}

.service {
    padding:30px}

.service ._intro, {
    line-height: 1.5;
    }

.service_nft ._icon img{
    width:50px}

.case_nft {
    padding: 30px;
    line-height: 1.5;
    text-align: left;}

</style>

